export const ka = {
  title: 'ტროპიკული მიწისზედა ცოცხალი ხის ბიომასის სიმკვრივე',
  subtitle: 'ტროპიკები, ზარინი/WHR',
  download_data: 'http://data.globalforestwatch.org/datasets/8f93a6f94a414f9588ce4657a39c59ff_1',
  content: [
    {
      label: 'ფუნქცია',
      value: 'აჩვენებს მიწისზედა ცოცხალი ხის ბიომასის ნახშირბადის სიმკვრივის მნიშვნელობებს',
    },
    {
      label: 'რეზოლუცია',
      value: '30 მ',
    },
    {
      label: 'გეოგრაფიული გაშუქება',
      value: 'ტროპიკები (30 გრადუსი ჩრდილო, 20 გრადუსი სამხრეთ)',
    },
    {
      label: 'წყარო',
      value: 'ICEsat GLAS lidar, MODIS, Landsat, მიწის გაზომვები',
    },
    {
      label: 'შინაარსის თარიღი',
      value: '2000 წ',
    },
    {
      label: 'გაფრთხილება',
      value:
        'რეკომენდირებულია, რომ მიწისზედა ნახშირბადის სიმკვრივისა და გაურკვევლობის მნიშვნელობები ერთად იქნას გამოყენებული ნახშირბადის შეფასებისა და გადამოწმებისთვის. რუკა უზრუნველყოფს მიწისზედა ნახშირბადის მარაგისა და მიწისზედა ნახშირბადის სიმკვრივის ზუსტ შეფასებებს, როდესაც აგრეგირებული იქნება დიდ ტერიტორიებზე (5000-დან 10000 ჰა-მდე) პროექტისა და რეგიონული დონის შეფასებისთვის. ერთი პიქსელის ბიომასის სიმკვრივის მნიშვნელობას შეიძლება ჰქონდეს დიდი გაურკვევლობა შემოწმების მცირე ნაკვეთებთან შედარებით.',
    },
    {
      label: 'ლიცენზია',
      value: 'Creative Commons CC BY 4.0',
    },
  ],
  overview: {
    label: 'მიმოხილვა',
    value:
      'ეს არის უფრო მაღალი გარჩევადობის მონაცემთა პროდუქტი, რომელიც აფართოებს მეთოდოლოგიას, რომელიც წარმოდგენილია Baccini et al. (2012) მიწისზედა ცოცხალი მერქნიანი ბიომასის სიმკვრივის პანტროპიკული რუქის გენერირებისთვის დაახლოებით 2000 წლისთვის 30 მ გარჩევადობით. ნახშირბადის სიმკვრივის მნიშვნელობებთან ერთად, არსებობს შეცდომის რუკა იმავე სივრცითი გარჩევადობით, რომელიც უზრუნველყოფს მიწისზედა ნახშირბადის სიმკვრივის შეფასების გაურკვევლობას. ეს რუქები იძლევა ბიომასის შეფასებების თანამდებარეობის საშუალებას ჰანსენთან და სხვებთან ერთად. (2013, v1.0) ხეების საფარის დანაკარგის შეფასება მსგავსი სივრცითი გარჩევადობით. სტატისტიკური კავშირი, რომელიც მიღებულია ტყის ბიომასის სიმკვრივის სახმელეთო გაზომვებსა და თანამდებარე Geoscience Laser Altimeter System (GLAS) LiDAR ტალღის ფორმის მეტრებს შორის, როგორც აღწერილია Baccini et al. (2012) გამოიყენეს ტროპიკებში 40000-ზე მეტი GLAS ნაკვალევის ბიომასის სიმკვრივის შესაფასებლად. შემდეგ, შემთხვევითი ფორესტის მოდელების გამოყენებით, ბიომასის სიმკვრივის GLAS-დან მიღებული შეფასებები იყო დაკავშირებული უწყვეტ, ბადისებრ ცვლადებთან, მათ შორის Landsat 7 ETM+ სატელიტური გამოსახულებები და პროდუქტები (მაგ., არეკვლა), სიმაღლე და ბიოფიზიკური ცვლადები. უწყვეტი ბადისებრი მონაცემთა ნაკრების შემთხვევითი ტყის მოდელების შესატანად გამოყენებით, შეიქმნა ტროპიკებში მიწისზედა ხის ბიომასის სიმკვრივის კედელიდან კედელამდე გარჩევადობის რუკა, ისევე როგორც დაკავშირებული გაურკვევლობის ფენა. გაურკვევლობის ფენა ითვალისწინებს შეცდომებს ალომეტრიული განტოლებიდან, LiDAR-ზე დაფუძნებული მოდელიდან და შემთხვევითი ფორესტის მოდელიდან. ყველა შეცდომა ვრცელდება ბიომასის საბოლოო შეფასებამდე. სამუშაოს დეტალური აღწერა მოხსენებული იქნება ახალ მომზადებულ ნაშრომში.',
  },
  citation: {
    label: 'ციტატა',
    value:
      'Baccini A., W. Walker, L. Carvahlo, M. Farina, D. Sulla-Menashe, R. Houghton (2015). ტროპიკული ტყეები არის ნახშირბადის წმინდა წყარო, რომელიც დაფუძნებულია მოგებისა და ზარალის ახალ გაზომვებზე. მიმოხილვაში. ხელმისაწვდომია Global Forest Watch Climate-ის მეშვეობით [თარიღი]. klima.globalforestwatch.org.',
  },
};
